import Reports from "./Reports";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.general.user
  };
};

export default connect(mapStateToProps, {})(Reports);